/**
 * @module Helper
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PreloadingStrategy, Route } from '@angular/router';

/**
 * Custom preloading strategy for lazy-loaded routes in the Angular application.
 *
 * This service implements the PreloadingStrategy interface to control the preloading
 * behavior of lazy-loaded modules based on route configuration. It allows for selective
 * preloading of routes that are marked with a specific data property.
 *
 * @helper
 * @@Injectable
 */
@Injectable()
export class CustomPreloadingStrategy implements PreloadingStrategy {
	/**
	 * Determines whether to preload a given route.
	 *
	 * @param {Route} route - The route configuration object to evaluate for preloading.
	 * @param {function(): Observable<any>} load - A function that returns an observable for loading the module.
	 * @returns {Observable<any>} An observable that emits the loaded module or null if not preloaded.
	 */
	preload(route: Route, load: () => Observable<any>): Observable<any> {
		if (route.data && route.data.preload) return load();
		return of(null);
	}
}
